const MODULE_ID = 'VU';

const BIRTH_OF_CHILDREN_CATALOGATION_CODE = '004';
const MATERNITY_CODE = 'MAT';
const PATERNITY_CODE = 'PAT';
const PATERNITY_SECOND_PERIOD_CODE = 'PA5';
const MATERNITY_SECOND_PERIOD_CODE = 'MA5';

const VA_SWITCH_CONFIG = [
  {
    text: 'VACATIONS_ABSENCES.GENERAL.VACATIONS',
    value: 'vacation',
  },
  {
    text: 'VACATIONS_ABSENCES.GENERAL.ABSENCE',
    value: 'absence',
  },
];

const COOKIES = {
  MODAL_WARNING_DELEGATION: 'dontShowModalDelegation',
};

const VA_MY_VACATIONS_MODAL_COACHMARK_CONFIG = {
  module: 'VA',
  tab: 'myVacations',
  state: 'my-vacations',
  title: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.TITLE',
  subtitles: [
    {
      text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP0',
    }, {
      text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP1',
    }, {
      text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP2',
    }, {
      text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP3',
    }, {
      text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP4',
    }, {
      text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP5',
    }, {
      text: 'VACATIONS_ABSENCES.COACHMARK.MY_VACATIONS.STEP6',
    },
  ],
  imgs: [
    {
      source: 'img/welcome-modal/vacations-absences/01-MV/01.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    }, {
      source: 'img/welcome-modal/vacations-absences/01-MV/02.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    }, {
      source: 'img/welcome-modal/vacations-absences/01-MV/03.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    }, {
      source: 'img/welcome-modal/vacations-absences/01-MV/04.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    }, {
      source: 'img/welcome-modal/vacations-absences/01-MV/05.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    }, {
      source: 'img/welcome-modal/vacations-absences/01-MV/06.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    }, {
      source: 'img/welcome-modal/vacations-absences/01-MV/07.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }
  ]
};

const VA_TEAM_REQUESTS_MODAL_COACHMARK_CONFIG = {
  module: 'VA',
  tab: 'teamRequests',
  state: 'team-requests',
  title: 'VACATIONS_ABSENCES.COACHMARK.TEAM_REQUESTS.TITLE',
  subtitles: [
    {
      text: 'VACATIONS_ABSENCES.COACHMARK.TEAM_REQUESTS.STEP0'
    }, {
      text: 'VACATIONS_ABSENCES.COACHMARK.TEAM_REQUESTS.STEP1'
    }
  ],
  imgs: [
    {
      source: 'img/welcome-modal/vacations-absences/02-TR/01.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }, {
      source: 'img/welcome-modal/vacations-absences/02-TR/02.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }
  ]
};

const VA_TEAM_CALENDAR_MODAL_COACHMARK_CONFIG = {
  module: 'VA',
  tab: 'teamCalendar',
  state: 'team-calendar',
  title: 'VACATIONS_ABSENCES.COACHMARK.TEAM_CALENDAR.TITLE',
  subtitles: [
    {
      text: 'VACATIONS_ABSENCES.COACHMARK.TEAM_CALENDAR.STEP0'
    }, {
      text: 'VACATIONS_ABSENCES.COACHMARK.TEAM_CALENDAR.STEP1'
    }
  ],
  imgs: [
    {
      source: 'img/welcome-modal/vacations-absences/03-TC/01.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    },
    {
      source: 'img/welcome-modal/vacations-absences/03-TC/02.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }
  ]
};

const VA_DELEGATIONS_MODAL_COACHMARK_CONFIG = {
  module: 'VA',
  tab: 'delegations',
  state: 'delegations',
  title: 'VACATIONS_ABSENCES.COACHMARK.DELEGATIONS.TITLE',
  subtitles: [
    {
      text: 'VACATIONS_ABSENCES.COACHMARK.DELEGATIONS.STEP0'
    }, {
      text: 'VACATIONS_ABSENCES.COACHMARK.DELEGATIONS.STEP1'
    }, {
      text: 'VACATIONS_ABSENCES.COACHMARK.DELEGATIONS.STEP2'
    }
  ],
  imgs: [
    {
      source: 'img/welcome-modal/vacations-absences/04-PD/01.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }, {
      source: 'img/welcome-modal/vacations-absences/04-PD/02.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }, {
      source: 'img/welcome-modal/vacations-absences/04-PD/03.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT'
    }
  ]
};

const RESOLUTION = {
  DESKTOP: 1200,
};

const SINDICAL_REPRESENTATION_HOURS_CODE = 'CS1';

const MAX_HOURS = {
  SINDICAL_REPRESENTATION: 9.75,
  GENERAL_HOURLY_ABSENCES: 7
};

const REQUEST_ERRORS = {
  DATE: 'FECHAS_PARTE_INCORRECTAS',
  COLEGIATE: '0NUU02',
  DATE_OVERLAP: 'W8AG24',
  NO_FUTURE: 'ERROR_AUSENCIA_NOFUTURO',
  BAD_REQUEST: 400
};

export {
  MODULE_ID,
  BIRTH_OF_CHILDREN_CATALOGATION_CODE,
  PATERNITY_CODE,
  PATERNITY_SECOND_PERIOD_CODE,
  MATERNITY_SECOND_PERIOD_CODE,
  MATERNITY_CODE,
  VA_SWITCH_CONFIG,
  COOKIES,
  VA_MY_VACATIONS_MODAL_COACHMARK_CONFIG,
  VA_TEAM_CALENDAR_MODAL_COACHMARK_CONFIG,
  VA_TEAM_REQUESTS_MODAL_COACHMARK_CONFIG,
  VA_DELEGATIONS_MODAL_COACHMARK_CONFIG,
  RESOLUTION,
  SINDICAL_REPRESENTATION_HOURS_CODE,
  MAX_HOURS,
  REQUEST_ERRORS
};



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/domain/constants.js